module.exports = __webpack_public_path__ + "static/img/home.0aa38a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home.jpg
// module id = mUNP
// module chunks = 1